<template>
  <div class="yueBao-wrap">
    <van-nav-bar
        left-arrow
        title="余额宝"
        :border="false"
        @click-left="onClickLeft"
    />
    <div class="yueBao-main-wrap">
      <!-- 顶部数据 -->
      <div class="yueBao-header">
        <div class="yueBao-header-item">
          <div class="yueBao-header-item-title">已存入：</div>
          <div class="yueBao-header-item-desc">
            {{ yueBaoData?.amount }} {{store.state.publicConfig.title}}
            <div class="yueBao-balance-tips">
              日利率
            </div>
          </div>
        </div>
        <div class="yueBao-header-item yueBao-header-item-limit">
          <div class="yueBao-header-item-title">结算周期：</div>
          <div class="yueBao-header-item-desc"><span>{{ yueBaoConfig?.store_cycle }}</span>天(封顶<span>7</span>周期)</div>
        </div>
        <div class="yueBao-header-item">
          <div class="yueBao-header-item-title">已领取：</div>
          <div class="yueBao-header-item-desc">{{ yueBaoData?.receive_amount }} {{store.state.publicConfig.title}}</div>
        </div>
        <div class="yueBao-header-item">
          <div class="yueBao-header-item-title">待领取：</div>
          <div class="yueBao-header-item-desc yueBao-header-item-draw">{{ yueBaoData?.not_receive_amount }} {{store.state.publicConfig.title}}</div>
        </div>
      </div>
      <!-- 操作按钮 -->
      <div class="yueBao-btn-wrap">
        <van-button
          type="primary"
          size="large"
          block
          class="yueBao-btn"
          @click="showInDialog = true"
        >
        <img class="entry-text" src="../../assets/images/yuebao/in.png" />
        存入
        </van-button>
        <van-button
          type="primary"
          size="large"
          block
          class="yueBao-btn"
          @click="showOutDialog = true"
        >
        <img class="entry-text" src="../../assets/images/yuebao/out.png" />
        转出
        </van-button>  
        <van-button
          type="primary"
          size="large"
          block
          class="yueBao-btn"
          @click="getReceive"
        >
        <img class="entry-text" src="../../assets/images/yuebao/draw.png" />
        领取
        </van-button>  
      </div>
      <!-- 图形表 -->
      <div class="yueBao-chart-wrap">
        <div class="yueBao-chart-tabs">
          <div
            v-for="(item, index) in chartTabs"
            :key="index"
            :class="{ active: currentChartTab === item.key }"
            class="yueBao-chart-tabs-item">
            {{ item.name }}
          </div>
        </div>
        <!-- 图形表 -->
        <Chart :yData="yData" :xData="xData"/>
      </div>
      <!-- 交易记录 -->
      <div class="yueBao-footer-wrap">
        <div class="yueBao-footer-tabs">
          <div
            v-for="(item, index) in typeTabs"
            :key="index"
            :class="{ active: currentTypeTab === item.key }"
            @click="changeTypeTab(item.key)"
            class="yueBao-footer-tabs-item">
            {{ item.name }}
          </div>
        </div>
        <template v-if="currentTypeTab === 'record'">
          <div class="yueBao-top">
            <div class="yueBao-top-select">
                <div class="yueBao-top-select-item" @click="changeRecordSelect(0)">
                    <div class="yueBao-top-select-item-text">
                        {{ currtentTimeSelect.text }}
                    </div>
                    <div class="yueBao-top-select-item-icon">
                      <img :src="themeImgs.yueBaoArrowDown" alt="">
                    </div>
                </div>
                <div class="yueBao-top-select-item" @click="changeRecordSelect(1)">
                    <div class="yueBao-top-select-item-text"> {{ currtentTypeSelect.text }}</div>
                    <div class="yueBao-top-select-item-icon">
                      <img :src="themeImgs.yueBaoArrowDown" alt="">
                    </div>
                </div>
            </div>
            <div class="yueBao-top-text">
              累计收益：<span class="yueBao-top-text-money">{{ totalReceive }} {{store.state.publicConfig.title}}</span>
            </div>
          </div>
          <Record
            :recordData="recordData"
            :currentPage="currentPage"
            :pageSize="pageSize"
            :totalPage="totalRecordPage"
            :totalCount="totalRecordCount"
            @update:currentPage="changeRecordPage"
            @update:pageSize="changeRecordPageSize"
            />
        </template>
        <Rule
          v-if="currentTypeTab === 'rule'"
          :record="yueBaoConfig"
        />

      </div>
    </div>
    <!-- 转入弹出框 -->
    <van-dialog
      v-model:show="showInDialog"
      title="转入"
      :show-confirm-button="false"
      :close-on-click-overlay="true"
      :before-close="onCloseDiloag"
      className="yueBao-dialog"
    >
      <div class="yueBao-in-main">
        <div class="yueBao-in-header">
          <div class="yueBao-in-header-item">
            <div class="yueBao-in-header-item-title">账号余额：</div>
            <div class="yueBao-in-header-item-desc">
              {{store.state.memberAmountObj.currency_money || '0.00'}}
              <span class="yueBao-in-header-item-desc-refresh" :class="{ rotate: isRotate }">
                <van-icon
                  :name="themeImgs.refreshYue"
                  @click="refreshYue"
                />
              </span>
            </div>
          </div>
          <div class="yueBao-in-header-item">
            <div class="yueBao-in-header-item-title">结算周期：</div>
            <div class="yueBao-in-header-item-desc">{{ yueBaoConfig.store_cycle }}天</div>
          </div>
        </div>
        <div class="yueBao-in-input">
          <van-field
            center
            type="text"
            v-model="yueBaoInMoney"
            :formatter="formatter"
            autocomplete="off"
            placeholder="单笔仅限整数"
          >
              <template #left-icon>
                <div class="yueBao-in-symbol"> {{store.state.publicConfig.title}}</div>
              </template>
              <template #right-icon>
                 <div class="yueBao-in-all" @click="onClickBalanceAll('in')">全部金额</div>
              </template>
          </van-field>
        </div>
        <div class="yueBao-in-input-msg" v-if="showInErrorMsg">{{ inErrorMsg }}</div>
        <div class="yueBao-in-tips">本次转入后，首次产生的利息时间约在：{{ outTime?.formattedTargetTime }}</div>
        <div class="yueBao-in-btn-wrap">
          <van-button
            type="primary"
            size="large"
            block
            class="yueBao-btn"
            @click="onClickInConfirm"
          >
          确认转入
          </van-button>
        </div>
        <div class="yueBao-in-tips">当前时间：{{ curTime }}</div>
      </div>
    </van-dialog>

    <!-- 转出弹出框 -->
    <van-dialog
      v-model:show="showOutDialog"
      title="转出"
      :show-confirm-button="false"
      :close-on-click-overlay="true"
      :before-close="onCloseDiloag"
      className="yueBao-dialog"
    >
      <div class="yueBao-in-main">
        <div class="yueBao-in-header">
          <div class="yueBao-in-header-item">
            <div class="yueBao-in-header-item-title">余额宝余额：</div>
            <div class="yueBao-in-header-item-desc">
              {{ yueBaoData.amount }}
              <span class="yueBao-in-header-item-desc-refresh" :class="{ rotate: isRotate }">
                <van-icon
                  :name="themeImgs.refreshYue"
                  @click="getHomeMsg"
                />
              </span>
            </div>
          </div>
          <div class="yueBao-in-header-item">
            <div class="yueBao-in-header-item-title">结算周期：</div>
            <div class="yueBao-in-header-item-desc">{{  yueBaoConfig.store_cycle }}天</div>
          </div>
        </div>
        <div class="yueBao-in-input">
          <van-field
            center
            type="text"
            v-model="yueBaoOutMoney"
            :formatter="formatter"
            autocomplete="off"
            placeholder="单笔仅限整数">
              <template #left-icon>
                <div class="yueBao-in-symbol"> {{store.state.publicConfig.title}}</div>
              </template>
              <template #right-icon>
                 <div class="yueBao-in-all" @click="onClickBalanceAll('out')">全部金额</div>
              </template>
          </van-field>
        </div>
        <div class="yueBao-in-input-msg" v-if="showOutErrorMsg">{{ outErrorMsg }}</div>
        <div class="yueBao-in-btn-wrap">
          <van-button
            type="primary"
            size="large"
            block
            class="yueBao-btn"
            @click="onClickOutConfirm"
          >
          确认转出
          </van-button>
        </div>
        <div class="yueBao-in-tips">本轮结算倒计时
          <van-count-down
            v-if="showOutDialog"
            ref="countDown"
            :time="outTime?.diffMilliseconds"
            :auto-start="true"
            @finish="onFinishTimeCount"/>
        </div>
      </div>
    </van-dialog>
    <!-- 密码弹出框 -->
    <van-dialog
      v-model:show="showPassDialog"
      :title="passwordTitle"
      :show-confirm-button="false"
      :close-on-click-overlay="true"
      :before-close="onCloseDiloag"
      className="yueBao-dialog"
    >
      <div class="yueBao-in-main yueBao-password-main">
        <div class="yueBao-in-tips">为了您的账户安全，请输入提现密码</div>
        <div class="yueBao-in-input" @click="focusInput">
            <!-- <van-password-input
              :value="passworValue"
              :gutter="10"
              :length="6"
              :mask="isShowPasswordMask"
              :focused="showKeyboard"
              @focus="showKeyboard = true"
            /> -->

          <!-- 真正可输入的 input -->
          <input
            ref="realInput"
            v-model="passworValue"
            maxlength="6"
            type="text"
            inputmode="numeric"
            class="real-input"
            @blur="handleBlur"
          />

          <!-- 展示输入内容的组件 -->
          <van-password-input
            :value="passworValue"
            :length="6"
            :gutter="10"
            :mask="isShowPasswordMask"
            :focused="isFocused"
          />
        </div>
        <div class="yueBao-in-input-msg" v-if="showpasswordErrorMsg">请输入正确密码</div>
        <div class="yueBao-password-tips">
          <div class="yueBao-pwssword-forget" @click="setShowServicePopup(true)">忘记密码？</div>
          <div class="yueBao-password-isshow">
            <div class="yueBao-password-isshow-tips">显示密码</div>
            <div class="yueBao-password-isshow-content">
              <span class="open">开</span>
              <van-switch v-model="isShowPasswordMask" />
              <span class="close">关</span>
            </div>
          </div>
        </div>
        <div class="yueBao-in-btn-wrap">
          <van-button
            type="primary"
            size="large"
            block
            class="yueBao-btn"
            @click="onClickConfirm"
          >
          确认
          </van-button>
        </div>
      </div>
    </van-dialog>
    <!-- 数字键盘弹出框 -->
    <van-popup
      v-model:show="showKeyboard"
      position="bottom"
      :close-on-click-overlay="false"
      :close-on-click-modal="false"
      :style="{ height: 'auto' }"
      class="yueBao-keyboard-popup"
    >
      <div class="yueBao-keyboard">
        <van-number-keyboard
          v-model="passworValue"
          :show="showKeyboard"
          @blur="showKeyboard = false"
        />
      </div>
    </van-popup>

     <!-- 展示交易记录选择-->
     <van-popup
        v-model:show="showRecordSelectPopup"
        position="bottom"
        :closeable="true"
        class="yueBao-record-select-popup"
        >
        <div class="yueBao-record-select-popup-title">{{ recordSelectTitle }}</div>
        <van-row class="yueBao-record-select-popup-select" type="flex">
            <van-col
                v-for="(item, index) in recordSelectOptions"
                :key="index"
                :value="item.text"
                :center="true"
                :class="{ 'active': item.value === recordSelectOptionsValue }"
                @click="changeRecord(item)"
                span="24"
            >
                {{ item.text }}
            </van-col>
        </van-row>
    </van-popup>
  </div>
</template>

<script setup>
import Record from './components/Record.vue'
import Chart from './components/Chart.vue'
import Rule from './components/Rule.vue'
import { ref, computed, onMounted, nextTick, onBeforeUnmount, watch } from 'vue'
import { useRouter } from "vue-router";
import { Toast } from "vant";
import { useStore } from 'vuex'
import date from '@/utils/date'
import { detectOS } from '@/utils'
import moment from 'moment'
import { getYueBaoHome,
  postYueBaoTransfer,
  postYueBaoTransferOut,
  getYueBaoConfig,
  getYueBaoGetRecordList,
  getMemberAmount,
  postYueBaoAddReceive
} from '@/api/api'

const $router = useRouter()
const store = useStore()

// 主题图片
const themeImgs = computed(() => store.state.themeImgs)

// 防暴击参数
const loading = ref(false)
// 图表
const currentChartTab = ref('1')
const yData = ref([])
const xData = ref([])

// 转入弹框
const showInDialog = ref(false)
const showOutDialog = ref(false)
const showPassDialog = ref(false)

// 密码弹框title
const passwordTitle = computed(() => {
  return currentOperation.value === 'in' ? '转入密码' : '提现密码'
})
// 重置利息时间-当前时间差额
const countDown = ref(null)

const outTime = computed(() => {
  // 计算转出倒计时
  if (countDown.value || showInDialog.value || showOutDialog.value) {
    const resetRateTime = yueBaoConfig.value?.reset_rate_time || '00:00:00'
    const [hours, minutes, seconds] = resetRateTime.split(':').map(Number)
    return date.getTimeDiff(hours, minutes, seconds)
  }
  return {
    formattedTargetTime: '00:00:00',
    diffMilliseconds: 0
  }
})

const onFinishTimeCount = () => {
  // 转出倒计时结束逻辑
  // const resetRateTime = yueBaoConfig.value?.reset_rate_time || '00:00:00'
  // const [hours, minutes, seconds] = resetRateTime.split(':').map(Number)
  // outTime.value = date.getTimeDiff(hours, minutes, seconds)

  // 重新获取余额宝数据
  getHomeMsg()
  handleGetMemberAmount()
  // 重新倒计时
  countDown.value.reset()
  countDown.value.start()
}

// 关于余额宝基础数据
const yueBaoData = ref({
  amount: 0, // 已存入
  cycle_day: 0, // 已领取
  not_receive_amount: 0, // 未领取
  receive_amount: 0 // 结算周期
})
const getHomeMsg = () => {
  xData.value = [] // 重置x轴数据
  yData.value = [] // 重置y轴数据
  getYueBaoHome().then(res => {
    if(res.result !== 200000) {
      Toast(res.msg || `新功能即将上线，敬请期待！`)
      // $router.push('/')
    }
    if (loading.value) return
    loading.value = true
    isRotate.value = true
    yueBaoData.value = res.data.list
    // console.log('yueBaoData', Object.entries(yueBaoData.value.day_list))
    yueBaoData.value?.day_list && Object.entries(yueBaoData.value?.day_list).forEach(item => {
      // 处理日期格式
      xData.value = [...xData.value, moment(item[0]).format('MM-DD')]
      yData.value = [...yData.value, item[1].total_revenue]
    })
    setTimeout(() => {
      isRotate.value = false
      loading.value = false
    }, 1000)
  })
}

const totalReceive = computed(() => {
  // 计算总收益
  return yueBaoData.value?.receive_amount && (yueBaoData.value?.receive_amount * 1 + yueBaoData.value?.not_receive_amount  * 1).toFixed(2) || 0
})

// 获取余额宝配置
const yueBaoConfig = ref({
  day_rate: 0, // 日利率
  day_max_money: 0, // 结算周期
  income_time: '00:00:00', // 收益时间
  no_income_time: 0, // 不收益时间
  reset_rate_time: '00:00:00', // 重置利率时间
  store_cycle: 0 // 存入周期
})
getYueBaoConfig().then(res => {
  if(res.result !== 200000) {
    Toast(res.msg || '新功能即将上线，敬请期待！')
    $router.push('/')
  }
  yueBaoConfig.value = res.data.list
})

// 只能输入正整数
const formatter = (value) => value.match(/^\d*/g)[0]

// 是否显示键盘
const showKeyboard = ref(false)
// 当前输入的密码
const passworValue = ref('')
// 是否展示密码明文
const isShowPasswordMask = ref(false)

const yueBaoInMoney = ref('')
const yueBaoOutMoney = ref('')
const password = ref('')



const isFocused = ref(false)
const realInput = ref(null)

const focusInput = () => {
  isFocused.value = true
  realInput.value?.focus()
  // 判断是否现实键盘
  const decive = detectOS()
  if (['ios', 'android'].includes(decive)) {
    showKeyboard.value = true
  }
}

const handleBlur = () => {
  console.log('handleBlur')
  isFocused.value = false
}

const curTime = ref('')
watch(() => showInDialog.value, (newVal) => {
  // 更新当前时间
  timer && clearInterval(timer)
  if (newVal) {
    curTime.value = date.curDateTime()
    countTime()
  }
})

let timer = null
const countTime = () => {
  timer = setInterval(() => {
    curTime.value = date.curDateTime()
  }, 1000)
}


// 图形表数据
const chartTabs = ref([
  { name: '收益走势', key: '1' }
])

onMounted(() => {
  // 初始化图形表数据
  getRecordList()
  getHomeMsg()
})

// 在组件卸载前清理定时器和图形表数据
onBeforeUnmount(() => {
  // 清理定时器
  if (countDown.value) {
    countDown.value.reset()
    countDown.value = null
  }
  // 清理图形表数据
  yData.value = []
  xData.value = []
})

// 当前交易记录
const typeTabs = ref([
  { name: '记录明细', key: 'record' },
  { name: '利息规则', key: 'rule' }
])
const showRecordSelectPopup = ref(false)

const currentTypeTab = ref('record')
const currentPage = ref(1)
const pageSize = ref(5)
const recordData = ref()

const recordSelectTitle = ref('选择日期')
const currentRecordSelect = ref(0)
const currtentTimeSelect = ref({
  text: '今日',
  value: 'today'
})
const currtentTypeSelect = ref({
  text: '全部类型',
  value: ''
})

// 选择日期或类型
const changeRecordSelect = (key) => {
  currentRecordSelect.value = key
  currentPage.value = 1
  if (key === 0) {
    recordSelectTitle.value = '选择日期'
  } else {
    recordSelectTitle.value = '选择类型'
  }
  showRecordSelectPopup.value = true
}

// 选择日期或类型
const changeRecord = (item) => {
  showRecordSelectPopup.value = false
  if (currentRecordSelect.value === 0) {
    currtentTimeSelect.value = item
  } else {
    currtentTypeSelect.value = item
  }
  getRecordList()
}

const recordSelectOptions = computed(() => {
  return currentRecordSelect.value === 0
    ? [
        { text: '今日', value: 'today' },
        { text: '昨日', value: 'yesterday'  },
        { text: '七天', value: 'last7' }
      ]
    : [
        { text: '全部类型', value: '' },
        { text: '系统转出', value: 1 },
        { text: '收益', value: 2 },
        { text: '转出', value: 3 },
        { text: '转入', value: 4 }
      ]
})

const recordSelectOptionsValue = computed(() => {
  return currentRecordSelect.value === 0
    ? currtentTimeSelect.value.value
    : currtentTypeSelect.value.value
})
const changeTypeTab = (key) => {
  currentTypeTab.value = key
  if (key === 'record') {
    getRecordList()
  }
}

// 计算总页数
const totalRecordPage =ref(0)
const totalRecordCount =ref(0)

const getRecordList = () => {
  // 获取交易记录列表逻辑
  const dateRange = date.getDateRange(currtentTimeSelect.value.value)
  const params = {
    page: currentPage.value,
    pageSize: pageSize.value,
    type: currtentTypeSelect.value.value,
    start_day: dateRange[0],
    end_day: dateRange[1]
  }
  // 显示记录明细
  getYueBaoGetRecordList(params).then(res => {
    if (res.result === 200000) {
      recordData.value = res.data.list.data || []
      totalRecordPage.value = res.data.list.pageCount || 0
      totalRecordCount.value = res.data.list.count || 0
    } else {
      Toast(res.msg || '获取记录失败')
    }
  }).catch(err => {
    Toast('获取记录失败，请稍后再试')
  })
}

const changeRecordPage = (page) => {
  currentPage.value = page
  // 分页逻辑
  getRecordList()
}
const changeRecordPageSize = (size) => {
  pageSize.value = size
  // 每页条数逻辑
  getRecordList()
}
const isRotate = ref(false)
// 刷新余额
const refreshYue = () => {
  // 刷新余额逻辑
  if(loading.value) return
  loading.value = true
  nextTick()
  isRotate.value = true
  handleGetMemberAmount()
  setTimeout(() => {
    isRotate.value = false
    loading.value = false
  }, 1000)
}

// 全部金额
const onClickBalanceAll = (type) => {
  // 全部金额逻辑
  if (type === 'in') {
    yueBaoInMoney.value = store.state.memberAmountObj.currency_money || '0.00'
  } else {
    yueBaoOutMoney.value = store.state.memberAmountObj.currency_money || '0.00'
  }
}

// 点击导航栏左侧返回键
const onClickLeft = () => {
  // 返回首页
  $router.push('/')
}

// 点击转入按钮
const currentOperation = ref('in')  // 当前操作的输入框 转入或者转出
const showInErrorMsg = ref(false)
const inErrorMsg = ref('')
const onClickInConfirm = () => {
  if (yueBaoInMoney.value === '') {
    // 提示输入金额
    showInErrorMsg.value = true
    inErrorMsg.value = '请正确输入转入金额'
    return
  }
  // 转入逻辑
  clearInterval(timer)
  showInDialog.value = false
  currentOperation.value = 'in'
  showPassDialog.value = true
}

// 点击转出按钮
const showOutErrorMsg = ref(false)
const outErrorMsg = ref('')
const onClickOutConfirm = () => {
  if (yueBaoOutMoney.value === '') {
    // 提示输入金额
    showOutErrorMsg.value = true
    outErrorMsg.value = '请正确输入转出金额'
    return
  }
  showOutDialog.value = false
  showPassDialog.value = true
  currentOperation.value = 'out'
}

// 点击确认密码按钮
const showpasswordErrorMsg = ref(false)
const passwordErrorMsg = ref('')
const onClickConfirm = () => {
  if (passworValue.value === '' || passworValue.value.length < 6) {
    // 提示输入密码
    showpasswordErrorMsg.value = true
    passwordErrorMsg.value = '请输入正确密码'
    return
  }
  if(loading.value) return
  loading.value = true
  // 截取密码前6位
  passworValue.value = passworValue.value.slice(0, 6)
  // 密码逻辑
  let api = currentOperation.value === 'in' ? postYueBaoTransfer : postYueBaoTransferOut
  api({
    amount: currentOperation.value === 'in' ? yueBaoInMoney.value : yueBaoOutMoney.value,
    pay_password: passworValue.value
  }).then(res => {
    if (res.result === 200000) {
      Toast('操作成功')
      // 关闭弹出框，重新请求余额
      handleGetMemberAmount()
      getHomeMsg()
      getRecordList()
      onCloseDiloag()
    } else {
      Toast(res.msg || '操作失败')
    }
    loading.value = false
  }).catch(err => {
    Toast('操作失败，请稍后再试')
  })
}

   // 获取可售余额
   const handleGetMemberAmount = () => {
      getMemberAmount().then(res => {
          if(res.result == 200000) {
            store.dispatch('saveMemberAmountActions', res.data.info)
          }
      })
  }

// 关闭弹出框
const onCloseDiloag = () => {
  showInDialog.value = false
  showOutDialog.value = false
  showPassDialog.value = false
  showKeyboard.value = false
  passworValue.value = ''
  yueBaoInMoney.value = ''
  yueBaoOutMoney.value = ''
  showInErrorMsg.value = false
  showOutErrorMsg.value = false
  showpasswordErrorMsg.value = false
  inErrorMsg.value = ''
  outErrorMsg.value = ''
  passwordErrorMsg.value = ''
  loading.value = false
  // 清除倒计时
  if (countDown.value) {
    countDown.value.reset()
    countDown.value = null
  }
}

// 找回密码 联系客服
const setShowServicePopup = (flag) => {
  store.commit('setShowServicePopup', flag)
}

// 领取利息
const getReceive = () => {
  if(loading.value) return
  loading.value = true
  // 领取利息逻辑
  postYueBaoAddReceive().then(res => {
    if (res.result === 200000) {
      Toast('领取成功')
      // 重新请求余额和记录
      getHomeMsg()
      getRecordList()
    } else {
      Toast(res.msg || '领取失败')
    }
    loading.value = false
  }).catch(err => {
    Toast('领取失败，请稍后再试')
  })
}
</script>

<style lang="less" scoped>
.yueBao-wrap {
  height: 100%;
  background-color: #fff;
  .yueBao-main-wrap {
    .yueBao-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;
      padding: 16px;
      .yueBao-header-item {
        display: flex;
        align-items: center;
        font-size: 12px;
        margin: 5px 0;
        width: 50%;
        // flex: auto;
        .yueBao-header-item-title {
          color: #00000099;
          font-family: Roboto;
          font-size: 12px;
        }
        .yueBao-header-item-desc {
          color: #000;
          font-family: RobotoMedium;
          font-size: 12px;
          position: relative;
          span {
            color: #09794D;
          }
          &.yueBao-header-item-draw {
            color: #09794D;
          }
          // 气泡提示框
          .yueBao-balance-tips {
            width: max-content;
            padding: 3px 4px;
            margin: 8px 0;
            border-radius: 6px;
            position: absolute;
            top: -28px;
            right: -35px;
            font-size: 10px;
            line-height: 1.5;
            word-wrap: break-word;
            background-color: #ED4242;
            color: #fff;
            align-self: flex-end;
            border-bottom-left-radius: 0;
            &::after {
              content: '';
              position: absolute;
              left: 0px;
              top: 10px;
              width: 0;
              height: 0;
              border: 8px solid transparent;
              border-left-color: #ED4242;
            }
          }
        }
        // &.yueBao-header-item-limit {
        //   justify-content: flex-end;
        // }
      }
    }
    .yueBao-btn-wrap {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 10px;
      border-bottom: 1px solid #0000001A;
      padding:0 16px;
      padding-bottom: 10px;
      .yueBao-btn {
        height: 34px;
        border-radius: 6px;
        color: #000;
        line-height: 22px;
        :deep(.van-button__text) {
          display: flex;
          justify-content: center;
          align-items: center;
        }
        img {
          width: 22px;
          height: 22px;
          line-height: 22px;
        }
        &:first-child {
          background-color: #FFDD58;
        }
        &:nth-child(2) {
          background-color: #71B5F9;
        }
        &:last-child {
          background-color: #2EBD85;
        }
      }
    }
    .yueBao-chart-wrap {
      padding-bottom: 10px;
      border-bottom: 1px solid #0000001A;
      .yueBao-chart-tabs {
        width: 106px;
        height: 28px;
        border: 1px solid #DCDCDC;
        margin: 10px auto;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 10px;
        border-radius: 4px;
        .yueBao-chart-tabs-item {
          flex: 1;
          height: 26px;
          border-radius: 4px;
          line-height: 26px;
          text-align: center;
          background-color: #fff;
          color: #00000099;
          font-size: 12px;
          cursor: pointer;
          &.active {
            background-color: #519BF5;
            color: #fff;
          }
        }
      }
    }
    .yueBao-footer-wrap {
      padding: 16px;
      .yueBao-footer-tabs {
        width: 343px;
        height: 34px;
        background-color: #EBF6FF;
        margin: 10px auto;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 10px;
        border-radius: 4px;
        .yueBao-footer-tabs-item {
          flex: 1;
          height: 32px;
          border-radius: 4px;
          line-height: 32px;
          text-align: center;
          color: #00000099;
          font-size: 14px;
          cursor: pointer;
          &.active {
            background: linear-gradient(180deg, #8ED6FC 0%, #69ADF8 100%);
            color: #fff;
          }
        }
      }
      .yueBao-top {
        background-color: #fff;
        border-radius: 8px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 10px 0;
        .yueBao-top-select {
          display: flex;
          align-items: center;
          .yueBao-top-select-item {
              display: flex;
              align-items: center;
              gap: 5px;
              height: 28px;
              box-shadow: 0px 1px 2px 0px #76767640;
              border-radius: 4px;
              border: 1px solid #519BF5;
              padding: 3px 10px;
              margin-right: 10px;
              font-size: 12px;
              line-height: 24px;
              color: #519BF5;
              cursor: pointer;
              &:last-child {
                margin-right: 0;
              }
          }
        }
        .yueBao-top-text {
          flex: 1;
          display: flex;
          justify-content: flex-end;
          align-items: center;
          margin-left: 5px;
          font-size: 12px;
          font-weight: bold;
          color: #00000099;
          text-wrap: nowrap;
          word-break: normal;
          .yueBao-top-text-money {
            color: #519BF5;
            text-wrap: wrap;
            word-break: break-all;
          }
        }
      }
    }
  }
}

</style>
<style lang="less">
.yueBao-dialog {
  &.van-dialog {
    background: #fff;
    color: #000000;
    // z-index: 9999999 !important;
    .van-dialog__header {
      font-family: Inter;
      font-weight: 700;
      font-size: 18px;
      line-height: 100%;
      letter-spacing: 0%;
      color: #000;
    }
   .yueBao-in-main {
    margin: 16px;
    .yueBao-in-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;
      padding: 16px 0;
      .yueBao-in-header-item {
        display: flex;
        align-items: center;
        font-size: 12px;
        margin: 5px 0;
        .yueBao-in-header-item-title {
          color: #666666;
          font-family: Inter;
          font-size: 12px;
        }
        .yueBao-in-header-item-desc {
          color: #000;
          font-family: RobotoMedium;
          font-size: 14px;
          .yueBao-in-header-item-desc-refresh {
            .van-icon {
              width: 14px;
              height: 14px;
              img {
                width: 14px;
                height: 14px;
              }
            }
            &.rotate {
              width: 14px;
              height: 14px;
              .van-icon {
                width: 14px;
                height: 14px;
                img {
                  width: 14px;
                  height: 14px;
                  transform: rotate(360deg);
                  transition: transform 0.5s linear;
                }
              }
            }
          }
        } 
      }
    }
   }
   .yueBao-password-main {
    .yueBao-in-tips {
      text-align: left;
    }
    .yueBao-in-input {
    position: relative;
      .van-password-input {
        margin: 0;
      }
      .real-input {
        position: absolute;
        opacity: 0;
        pointer-events: none;
        z-index: -1;
      }
    }
    .yueBao-password-tips {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 10px;
      .yueBao-pwssword-forget {
        color: #519BF5;
        font-size: 11px;
        cursor: pointer;
      }
      .yueBao-password-isshow {
        display: flex;
        align-items: center;
        gap: 5px;
        .yueBao-password-isshow-tips {
          color: #000000CC;
          font-size: 11px;
        }
        .yueBao-password-isshow-content {
          display: flex;
          align-items: center;
          gap: 5px;
          position: relative;
          .open {
            color: #fff;
            font-size: 11px;
            position: absolute;
            left: 5px;
            z-index: 99;
          }
          .close {
            color: #000000CC;
            font-size: 11px;
            position: absolute;
            right: 5px;
          }
          .van-switch {
            width: 50px;
            height: 22px;
            background: #fff;
            border-radius: 22px;
            border: 1px solid #519BF5;
            .van-switch__node {
              width: 22px;
              height: 22px;
              background: #519BF5;
            }
            &.van-switch--on {
              background: #519BF5;
              .van-switch__node {
                width: 22px;
                height: 22px;
                background: #fff;
              }
            }
          }
        }
      }
    }
   }
    .yueBao-in-input {
      .van-field {
        background-color: #E8F3FB;
        border-radius: 6px;
        padding: 0 10px;
        height: 34px;
        line-height: 34px;
        font-size: 10px;
        .van-field__control {
          height: 34px;
          line-height: 34px;
          font-size: 12px;
          padding-left: 10px;
          &::placeholder {
            color: #00000099;
            font-size: 12px;
          }
        }
        .yueBao-in-symbol {
          color: #000;
          font-size: 14px;
          line-height: 34px;
        }
        .yueBao-in-all {
          color: #3080D3;
          font-size: 12px;
          line-height: 34px;
          margin-left: 10px;
        }
      }
      // 密码输入框
      .van-password-input__item {
        border: 0.91px solid #7f7a7a;
        border-radius: 7px;
        width: 38px;
        height: 38px;
      }
    }
    .yueBao-in-input-msg {
      line-height: 20px;
      margin-top: 10px;
      color: #E02020;
      font-size: 11px;
      width: 100%;
    }
    .yueBao-in-tips {
      display: flex;
      align-items: center;
      justify-content: center;
      line-height: 20px;
      margin-top: 10px;
      color: #00000099;
      font-size: 11px;
      width: 100%;
      text-align: center;
      .van-count-down {
        color: #00000099;
        font-weight: 400;
        font-size: 11px;
        // margin: 0 3px;
      }
    }
    .yueBao-in-btn-wrap {
      margin-top: 40px;
      .yueBao-btn {
        height: 40px;
        border-radius: 8px;
        background: linear-gradient(180deg, #8ED6FC 0%, #69ADF8 100%);
        color: #fff;
        line-height: 22px;
        .van-button__text {
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
    }
  }
}
.yueBao-record-select-popup {
  background-color: #fff;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  .yueBao-record-select-popup-title {
    font-size: 16px;
    font-weight: bold;
    color: #00000099;
    text-align: center;
    padding: 10px 0;
  }
  .yueBao-record-select-popup-select {
    background-color: #fff;
    border-radius: 8px;
    padding: 10px 0;
    .van-col {
      height: 40px;
      line-height: 40px;
      font-size: 14px;
      color: #00000099;
      text-align: center;
      border-bottom: 1px solid #E5E5E5;
      &:hover {
        background-color: #F8F8F8;
        cursor: pointer;
      }
      &:last-child {
        border-bottom: none;
      }
      &.active {
        background-color: #3080D3;
        color: #fff;
       }
    }
  }
  .rotate {
    transform: rotate(360deg);
  }
}
</style>
